<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<div class="card-title-block">
		<span class="card-title-label" translate>ecall-off.my-ecalls</span>
		<mat-form-field class="quick-search" appearance="outline" subscriptSizing="dynamic">
			<input [placeholder]="'search.placeholder' | translate" matInput type="text" spellcheck="false"
				autocomplete="off" [formControl]="searchTextControl" />
			<button type="button" *ngIf="searchTextControl.value" mat-icon-button (click)="searchTextControl.reset('');"
				tabindex="-1" matSuffix>
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
			<mat-icon svgIcon="search" class="quick-search-icon" *ngIf="!searchTextControl.value" matSuffix></mat-icon>
		</mat-form-field>
		<button type="button" class="filter-button" (click)="goToFilter()">
			<span class="filter-button-name" translate>datacenter.filters</span>
			<mat-icon class="filter-button-icon" svgIcon="filters"></mat-icon>
		</button>
	</div>
	<ng-container *ngIf="!isLoading else loading">
		<div class="grid-6 copo-container footer-margin" copoVirtualScroller [dataId]="dataId"
			#scroller="copoVirtualScroller"
			(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
			<div *ngFor="let ecall of scroller.list" class="grid-column-one-full card-block">
				<div class="card-portal">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon [svgIcon]="icon(ecall).id" [title]="icon(ecall).title"
										class="header-margin-right" color="blue"></mat-icon>
							<div class="card-container-column header-margin-right" [title]="getMills(ecall)">
								<span class="card-header-label" translate>order.mill</span>
								<span>{{ ecall.millDescription ? ecall.millDescription : UNDERSCORE }}</span>
							</div>
							<div class="card-container-column header-margin-right">
								<span class="card-header-label" translate>ecall-off.customer-call-off-reference</span>
							<span>{{ ecall.customerCallOffReference ? ecall.customerCallOffReference : UNDERSCORE
									}}</span>
							</div>
						</div>
					</div>
					<div class="card-content">
							<div class="container-ordered">
								<span class="tag-tonnage">{{ (ecall.quantitySum ? ecall.quantitySum: 0) | copoNumber:'weight':'t'
								}}</span>
							</div>

							<div class="card-container-column">
								<span class="card-content-label" translate>ecall-off-creation-date</span>
							<span>{{(ecall.callOffCreationTimestamp ? ecall.callOffCreationTimestamp : UNDERSCORE) | copoDate:'date'}}</span>
							</div>
						<div class="card-container-column card-column-around">
							<div class="card-container-link">
							<a mat-button color="primary" [routerLink]="['/ecall-off/ecall/card/', ecall.supplierCallOffNumber]">
									<span
										translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="card-mobile">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon svgIcon="in_stock" class="header-margin-right"></mat-icon>
						<span class="header-margin-right overflow-wrap">{{ ecall.supplierCallOffNumber }}</span>
						</div>
						<div>
							<span class="tag-tonnage">{{ (ecall.quantitySum ? ecall.quantitySum: 0) | copoNumber:'weight':'t'
								}}</span>
						</div>
					</div>
					<div class="card-content">
						<div class="content-grid-mobile">
							<div class="card-container-column card-column-end">
								<span class="card-content-label" translate>order.mill</span>
								<span>{{ ecall.millDescription ? ecall.millDescription : UNDERSCORE }}</span>
							</div>
							<div class="card-container-column ">
								<div class="card-container-column">
									<span class="card-content-label" translate>ecall-off-creation-date</span>
								<span class="overflow-wrap">{{(ecall.callOffCreationTimestamp ? ecall.callOffCreationTimestamp : UNDERSCORE) | copoDate:'date'}}</span>
								</div>
							</div>
						</div>
						<div class="card-container-column card-column-around">
							<div class="card-container-link">
							<a mat-button color="primary" [routerLink]="['/ecall-off/ecall/card/', ecall.supplierCallOffNumber]">
									<span
										translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
			<div translate class="empty-page-text grid-column-one-full"
				*ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>